module.exports = {
	"contractName": "InstanceFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "79:366:17:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;79:366:17;;;;;;",
	"deployedSourceMap": "79:366:17:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;117:131;;-1:-1:-1;;;;;117:131:17;;;;;;;;;-1:-1:-1;;;;;117:131:17;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;252:191:17;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;252:191:17;-1:-1:-1;;;;;252:191:17;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;117:131:17;182:7;217:26;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;210:33:17;117:131;-1:-1:-1;;117:131:17:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;252:191:17:-;338:4;365:17;394:9;365:39;;417:8;-1:-1:-1;;;;;417:19:17;;:21;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;417:21:17;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;417:21:17;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;417:21:17;;252:191;-1:-1:-1;;;;252:191:17:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;79:366:17:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.18;\n\nimport \"./base/Level.sol\";\nimport \"./Instance.sol\";\n\ncontract InstanceFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    return new Instance(\"ethernaut0\");\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    Instance instance = Instance(_instance);\n    return instance.getCleared();\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/InstanceFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/InstanceFactory.sol",
		"exportedSymbols": {
			"InstanceFactory": [
				1864
			]
		},
		"id": 1865,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1822,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:17"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1823,
				"nodeType": "ImportDirective",
				"scope": 1865,
				"sourceUnit": 2867,
				"src": "26:26:17",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Instance.sol",
				"file": "./Instance.sol",
				"id": 1824,
				"nodeType": "ImportDirective",
				"scope": 1865,
				"sourceUnit": 1821,
				"src": "53:24:17",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1825,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "107:5:17",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1826,
						"nodeType": "InheritanceSpecifier",
						"src": "107:5:17"
					}
				],
				"contractDependencies": [
					1820,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1864,
				"linearizedBaseContracts": [
					1864,
					2866,
					2922
				],
				"name": "InstanceFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1840,
							"nodeType": "Block",
							"src": "191:57:17",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1833,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1828,
										"src": "197:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1834,
									"nodeType": "ExpressionStatement",
									"src": "197:7:17"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "65746865726e61757430",
												"id": 1837,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "230:12:17",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_023f3e8b8ccd3fc58c78dde68a9d3ff4748caab6826784c9a56c96a37039de24",
													"typeString": "literal_string \"ethernaut0\""
												},
												"value": "ethernaut0"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_stringliteral_023f3e8b8ccd3fc58c78dde68a9d3ff4748caab6826784c9a56c96a37039de24",
													"typeString": "literal_string \"ethernaut0\""
												}
											],
											"id": 1836,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "217:12:17",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_string_memory_ptr_$returns$_t_contract$_Instance_$1820_$",
												"typeString": "function (string memory) returns (contract Instance)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1835,
												"name": "Instance",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1820,
												"src": "221:8:17",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Instance_$1820",
													"typeString": "contract Instance"
												}
											}
										},
										"id": 1838,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "217:26:17",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Instance_$1820",
											"typeString": "contract Instance"
										}
									},
									"functionReturnParameters": 1832,
									"id": 1839,
									"nodeType": "Return",
									"src": "210:33:17"
								}
							]
						},
						"documentation": null,
						"id": 1841,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1829,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1828,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1841,
									"src": "141:15:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1827,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "141:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "140:17:17"
						},
						"payable": true,
						"returnParameters": {
							"id": 1832,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1831,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1841,
									"src": "182:7:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1830,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "182:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "181:9:17"
						},
						"scope": 1864,
						"src": "117:131:17",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1862,
							"nodeType": "Block",
							"src": "346:97:17",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1850,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1845,
										"src": "352:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1851,
									"nodeType": "ExpressionStatement",
									"src": "352:7:17"
								},
								{
									"assignments": [
										1853
									],
									"declarations": [
										{
											"constant": false,
											"id": 1853,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1863,
											"src": "365:17:17",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Instance_$1820",
												"typeString": "contract Instance"
											},
											"typeName": {
												"contractScope": null,
												"id": 1852,
												"name": "Instance",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1820,
												"src": "365:8:17",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Instance_$1820",
													"typeString": "contract Instance"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1857,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1855,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1843,
												"src": "394:9:17",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1854,
											"name": "Instance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1820,
											"src": "385:8:17",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Instance_$1820_$",
												"typeString": "type(contract Instance)"
											}
										},
										"id": 1856,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "385:19:17",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Instance_$1820",
											"typeString": "contract Instance"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "365:39:17"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 1858,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1853,
												"src": "417:8:17",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Instance_$1820",
													"typeString": "contract Instance"
												}
											},
											"id": 1859,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "getCleared",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 1819,
											"src": "417:19:17",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 1860,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "417:21:17",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1849,
									"id": 1861,
									"nodeType": "Return",
									"src": "410:28:17"
								}
							]
						},
						"documentation": null,
						"id": 1863,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1846,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1843,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1863,
									"src": "278:17:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1842,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "278:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1845,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1863,
									"src": "297:15:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1844,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "297:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "277:36:17"
						},
						"payable": false,
						"returnParameters": {
							"id": 1849,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1848,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1863,
									"src": "338:4:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1847,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "338:4:17",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "337:6:17"
						},
						"scope": 1864,
						"src": "252:191:17",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1865,
				"src": "79:366:17"
			}
		],
		"src": "0:446:17"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/InstanceFactory.sol",
		"exportedSymbols": {
			"InstanceFactory": [
				1864
			]
		},
		"id": 1865,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1822,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:17"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1823,
				"nodeType": "ImportDirective",
				"scope": 1865,
				"sourceUnit": 2867,
				"src": "26:26:17",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Instance.sol",
				"file": "./Instance.sol",
				"id": 1824,
				"nodeType": "ImportDirective",
				"scope": 1865,
				"sourceUnit": 1821,
				"src": "53:24:17",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1825,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "107:5:17",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1826,
						"nodeType": "InheritanceSpecifier",
						"src": "107:5:17"
					}
				],
				"contractDependencies": [
					1820,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1864,
				"linearizedBaseContracts": [
					1864,
					2866,
					2922
				],
				"name": "InstanceFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1840,
							"nodeType": "Block",
							"src": "191:57:17",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1833,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1828,
										"src": "197:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1834,
									"nodeType": "ExpressionStatement",
									"src": "197:7:17"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "65746865726e61757430",
												"id": 1837,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "230:12:17",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_023f3e8b8ccd3fc58c78dde68a9d3ff4748caab6826784c9a56c96a37039de24",
													"typeString": "literal_string \"ethernaut0\""
												},
												"value": "ethernaut0"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_stringliteral_023f3e8b8ccd3fc58c78dde68a9d3ff4748caab6826784c9a56c96a37039de24",
													"typeString": "literal_string \"ethernaut0\""
												}
											],
											"id": 1836,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "217:12:17",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_string_memory_ptr_$returns$_t_contract$_Instance_$1820_$",
												"typeString": "function (string memory) returns (contract Instance)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1835,
												"name": "Instance",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1820,
												"src": "221:8:17",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Instance_$1820",
													"typeString": "contract Instance"
												}
											}
										},
										"id": 1838,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "217:26:17",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Instance_$1820",
											"typeString": "contract Instance"
										}
									},
									"functionReturnParameters": 1832,
									"id": 1839,
									"nodeType": "Return",
									"src": "210:33:17"
								}
							]
						},
						"documentation": null,
						"id": 1841,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1829,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1828,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1841,
									"src": "141:15:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1827,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "141:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "140:17:17"
						},
						"payable": true,
						"returnParameters": {
							"id": 1832,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1831,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1841,
									"src": "182:7:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1830,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "182:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "181:9:17"
						},
						"scope": 1864,
						"src": "117:131:17",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1862,
							"nodeType": "Block",
							"src": "346:97:17",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1850,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1845,
										"src": "352:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1851,
									"nodeType": "ExpressionStatement",
									"src": "352:7:17"
								},
								{
									"assignments": [
										1853
									],
									"declarations": [
										{
											"constant": false,
											"id": 1853,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1863,
											"src": "365:17:17",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Instance_$1820",
												"typeString": "contract Instance"
											},
											"typeName": {
												"contractScope": null,
												"id": 1852,
												"name": "Instance",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1820,
												"src": "365:8:17",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Instance_$1820",
													"typeString": "contract Instance"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1857,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1855,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1843,
												"src": "394:9:17",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1854,
											"name": "Instance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1820,
											"src": "385:8:17",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Instance_$1820_$",
												"typeString": "type(contract Instance)"
											}
										},
										"id": 1856,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "385:19:17",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Instance_$1820",
											"typeString": "contract Instance"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "365:39:17"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 1858,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1853,
												"src": "417:8:17",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Instance_$1820",
													"typeString": "contract Instance"
												}
											},
											"id": 1859,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "getCleared",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 1819,
											"src": "417:19:17",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 1860,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "417:21:17",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1849,
									"id": 1861,
									"nodeType": "Return",
									"src": "410:28:17"
								}
							]
						},
						"documentation": null,
						"id": 1863,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1846,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1843,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1863,
									"src": "278:17:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1842,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "278:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1845,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1863,
									"src": "297:15:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1844,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "297:7:17",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "277:36:17"
						},
						"payable": false,
						"returnParameters": {
							"id": 1849,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1848,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1863,
									"src": "338:4:17",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1847,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "338:4:17",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "337:6:17"
						},
						"scope": 1864,
						"src": "252:191:17",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1865,
				"src": "79:366:17"
			}
		],
		"src": "0:446:17"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.805Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/InstanceFactory.json
// module id = 1044
// module chunks = 0